module.exports = __webpack_public_path__ + "media/application/images/icons/test_white-27c9ebe6aae68870504baa082d78f9af.svg";